import React, { useState, useEffect } from "react";
import { Table } from "flowbite-react";
import Loading from "../../groups/Loading";
import ViewGroup from "../../groups/ViewGroup";
import TableGroup from "../../groups/TableGroup";
import { MdEdit, MdDelete } from "react-icons/md";
import TablePagination from "../../groups/TablePagination";
import endpoints from "../../../config/config";
import FinancialItemsForm from "./FinancialItemsForm";
import { fetch_list_data } from "../../../config/actions";
import ConfirmDelete from "../../groups/ConfirmDelete";
import ErrorGroup from "../../groups/ErrorGroup";
import { usePermission } from "../../../providers/PermissionProvider";
import { useDrawer } from "../../../providers/DrawerProvider";

const FinancialItems = () => {
    //////////////////////////////// providers ////////////////////////////////
    const { showDrawer, closeDrawer } = useDrawer();
    const { set_page_permissions } = usePermission();

    //////////////////////////////// permissions ////////////////////////////////
    const permissions = set_page_permissions("financials", "financialitem");
    if (!permissions.add && !permissions.view) {
        return (
            <p className="text-lg text-center text-red-600 py-4">
                ليس لديك صلاحيات هنا
            </p>
        );
    }

    //////////////////////////////// list data ////////////////////////////////
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fetchError, setFetchError] = useState(null);
    const [searchParam, setSearchParam] = useState(null);
    const [pageNumber, setPageNumber] = useState(1);

    const handleDrawer = (drawerFunction, item) => {
        if (drawerFunction == "edit") {
            showDrawer(
                "تعديل بند",
                MdEdit,
                <FinancialItemsForm
                    postURL={item.url}
                    defaultValues={item}
                    callBack={() => {
                        get_current_items();
                        closeDrawer();
                    }}
                />
            );
        } else {
            showDrawer(
                "حذف بند",
                MdDelete,
                <>
                    <ConfirmDelete
                        deleteURL={item.url}
                        deletePrompt={" هل أنت متأكد تريد حذف البند"}
                        itemName={item.name}
                        closeDrawer={closeDrawer}
                        callBack={() => {
                            setSearchParam(null);
                            setPageNumber(null);
                            get_current_items();
                        }}
                        toastMessage={"تم حذف البند بنجاح"}
                    />
                </>
            );
        }
    };

    const get_current_items = () => {
        const searchURL = `${endpoints.financial_item_list}${
            searchParam ? `&search=${searchParam}` : ""
        }${pageNumber ? `&page=${pageNumber}` : ""}
        `;

        fetch_list_data({
            searchURL: searchURL,
            setData: setData,
            setFetchError: setFetchError,
            setLoading: setLoading,
        });
    };

    useEffect(() => {
        if (permissions.view) {
            get_current_items();
        }
    }, [searchParam, pageNumber]);

    return (
        <>
            {/* add form */}
            {permissions.add ? (
                <FinancialItemsForm
                    postURL={endpoints.financial_item_list}
                    callBack={get_current_items}
                />
            ) : (
                <ErrorGroup title={"إضافة بند"} message={"ليس لديك صلاحية"} />
            )}

            {/* table data */}
            {permissions.view ? (
                <ViewGroup title={"البنود المالية الحالية"}>
                    {loading ? (
                        <Loading />
                    ) : fetchError ? (
                        <p className="text-lg text-center text-red-600 py-4">
                            خطأ في تحميل البيانات
                        </p>
                    ) : (
                        <>
                            <TableGroup
                                onChange={(event) => {
                                    setSearchParam(event.target.value);
                                    setPageNumber(1);
                                }}
                            >
                                {data.count == 0 ? (
                                    <Table.Body>
                                        <Table.Row className="text-lg text-center text-gray-800 py-3 font-bold bg-red-500">
                                            <Table.Cell>
                                                لا توجد بيانات
                                            </Table.Cell>
                                        </Table.Row>
                                    </Table.Body>
                                ) : (
                                    <>
                                        <Table.Head>
                                            <Table.HeadCell>
                                                اسم البند
                                            </Table.HeadCell>
                                            <Table.HeadCell>
                                                النوع
                                            </Table.HeadCell>
                                            <Table.HeadCell>
                                                إجراءات
                                            </Table.HeadCell>
                                        </Table.Head>
                                        <Table.Body>
                                            {data.results.map((item) => {
                                                return (
                                                    <Table.Row
                                                        key={item.id}
                                                        className="bg-white font-medium text-gray-900"
                                                    >
                                                        <Table.Cell>
                                                            {item.name ? (
                                                                item.name
                                                            ) : (
                                                                <span className="text-red-600">
                                                                    غير مسجل
                                                                </span>
                                                            )}
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            {item.financial_type ? (
                                                                item.financial_type ===
                                                                "expenses" ? (
                                                                    "مصروفات"
                                                                ) : (
                                                                    "إيرادات"
                                                                )
                                                            ) : (
                                                                <span className="text-red-600">
                                                                    غير مسجل
                                                                </span>
                                                            )}
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            <span className="flex text-xl gap-x-3">
                                                                {item.system_related ? (
                                                                    <span className="text-sm text-secondary">
                                                                        خاص
                                                                        بالنظام
                                                                    </span>
                                                                ) : (
                                                                    <>
                                                                        {permissions.change && (
                                                                            <MdEdit
                                                                                className="text-accent cursor-pointer"
                                                                                onClick={() => {
                                                                                    handleDrawer(
                                                                                        "edit",
                                                                                        item
                                                                                    );
                                                                                }}
                                                                            />
                                                                        )}
                                                                        {permissions.delete && (
                                                                            <MdDelete
                                                                                className="text-secondary cursor-pointer"
                                                                                onClick={() => {
                                                                                    handleDrawer(
                                                                                        "delete",
                                                                                        item
                                                                                    );
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </>
                                                                )}
                                                            </span>
                                                        </Table.Cell>
                                                    </Table.Row>
                                                );
                                            })}
                                        </Table.Body>
                                    </>
                                )}
                            </TableGroup>

                            {data.total_pages > 1 && (
                                <TablePagination
                                    totalPages={data.total_pages}
                                    currentPage={data.current_page}
                                    onPageChange={(page) => {
                                        setPageNumber(page);
                                    }}
                                />
                            )}
                        </>
                    )}
                </ViewGroup>
            ) : (
                <ErrorGroup
                    title={"البنود المالية الحالية"}
                    message={"ليس لديك صلاحية"}
                />
            )}
        </>
    );
};

export default FinancialItems;
